import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/ServiceSections";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 60);

export const FaqSection = ({ faqs, title = "Questions buyers ask", eyebrow = "FAQ" }) => {
  const [open, setOpen] = React.useState(0);
  if (!faqs?.length) return null;

  return (
    <section
      className="relative border-y border-white/10 bg-[#0A0E19]"
      data-testid="faq-section"
      aria-label="Frequently asked questions"
    >
      <div className="mx-auto max-w-4xl px-5 py-16 sm:px-8 sm:py-24 lg:px-16">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h2 className="mt-5 font-display text-[1.75rem] font-bold leading-[1.2] tracking-tight text-white sm:text-4xl sm:leading-tight">
            {title}
          </h2>
        </Reveal>
        <div className="mt-8 divide-y divide-white/10 border-t border-white/10 sm:mt-12">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} data-testid={`faq-item-${slug(f.q)}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-start justify-between gap-4 py-5 text-left"
                  data-testid={`faq-toggle-${i}`}
                >
                  <h3 className="text-[15px] font-semibold leading-snug text-white sm:text-base">{f.q}</h3>
                  <Plus
                    className={`mt-0.5 h-5 w-5 shrink-0 text-[#8E9AEA] transition-transform duration-300 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p
                        className="pb-6 pr-8 text-sm leading-relaxed text-[#DDE3F2] sm:text-[15px]"
                        data-testid={`faq-answer-${i}`}
                      >
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
